import {
  Box,
  Paper,
  Stack,
  Typography,
  IconButton,
  Collapse,
} from "@mui/material";
import { useContext, useState } from "react";
import { ExpandMore } from "@mui/icons-material";
import "../../../css/theatreTable.scss";
import { theme } from "../../../utilities/themes";
import { SeatsContext } from "../moviePage";
import dayjs from "dayjs";
import CinemaContent from "./cinemaContent";

/**A card showing the cinema layout and shows of a cinema in the movie page */
const CinemaCard = ({
  expanded = false, //Whether it is expanded or not
  onExpand, //a function to expand and minimize cinema cards based on their index
  cinema_Name = "Prestige cinema",
  cinema, //an object carrying the details of the cinema
  MovieID, //the ID of the movie in the movie page
  movieDetails, //the details of the movie
}) => {
  /* #region  States and UI controllers */
  const context = useContext(SeatsContext);
  const [hover, setHover] = useState(false);
  const spanFontSizes1 = {
    fontSize: { lg: "1.125rem", md: "1rem", sm: "0.875rem", xs: "0.8rem" },
  };
  const ExpandFunc = () => {
    if (!expanded) {
      context.setCinemaName(cinema_Name);
      context.setSelectedCinemaId(cinema.MovieProviderID);
    }
  };
  /* #endregion */

  const cinemaContentProps = {
    MovieProviderID: cinema.MovieProviderID,
    MovieID,
    movieDetails,
    ShowDate: dayjs().format("DD MMM"),
  };

  return (
    <Paper
      sx={{
        p: 3,
        position: "relative",
        cursor: expanded ? "default" : "pointer",
        border: "1px solid rgb(200,200,200)",
        borderLeft: "5px solid #E4572E",
      }}
      elevation={hover ? 4 : 2}
      onClick={() => {
        if (!expanded) {
          onExpand();
          setHover(false);
        }
        ExpandFunc();
      }}
      onMouseOver={() => !expanded && setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <IconButton
        sx={{ position: "absolute", top: "1.75vh", right: "0.25vw" }}
        onClick={() => {
          onExpand();
          ExpandFunc();
        }}
        size="large"
      >
        <ExpandMore
          color="primary"
          sx={{
            transform: expanded ? "rotate(180deg)" : "rotate(0)",
            fontSize: 24,
          }}
        />
      </IconButton>
      <Stack>
        <Box>
          <Typography
            component="span"
            sx={{
              ...spanFontSizes1,
              whiteSpace: "pre-wrap",
              textTransform: "uppercase",
              color: theme.palette.primary.main,
            }}
          >
            {cinema_Name}
          </Typography>
        </Box>
        {/* {expanded && (
          <>
            <CinemaContent {...cinemaContentProps} />
          </>
        )} */}
        <Collapse in={expanded}>
          <CinemaContent {...cinemaContentProps} />
        </Collapse>
      </Stack>
    </Paper>
  );
};

export default CinemaCard;
